<template>
<!-- push notification
  <flash-messages></flash-messages>
  -->
  <header>
    <login-logic :user="user" v-model:user="user"></login-logic>
  </header>

  <div
      data-dev="v2"
      class="vw-100 vh-100 d-flex flex-column flex-md-row m-0 p-0"
  >
    <main class="flex-grow-1 order-md-2 p-2 p-md-4 overflow-y-auto">
      <flash-messages
          v-if="getConfig('is_flash_message')"
      />

      <div v-if="!status.is_err">
        <div v-if="!status.is_loading">

          <component
              v-bind:is="moduleObj.component"
              v-model:reloadSignal="reloadSignal"
              :ident="$route.params.modul"
              :moduleData="moduleObj"
              :returnData="returnData"
              :route="$route"
          ></component>


        </div>
        <div
            v-else
            class="fullscreen-message d-flex align-items-center justify-content-center"
        >
          <div>
            <div class="text-center">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">{{$t('content.loading_short')}}</span>
              </div>
            </div>
            <span>{{$t('content.loading_full')}}</span>
          </div>
        </div>
      </div>
      <div  v-else-if="status.is_err" class="fullscreen-message d-flex align-items-center justify-content-center">
        <div class="alert alert-danger p-2">
          <div class="text-center">
            <i class="bi bi-exclamation-triangle-fill fs-1 text-danger"></i>
          </div>
          <span class="text-danger mt-2">{{status.err.message}}</span>
          <!--
          <pre>{{err}}</pre>
          -->
        </div>
      </div>

    </main>

    <nav class="order-md-1">
      <main-menu :user="user"></main-menu>
    </nav>
  </div>
</template>


<script>
import loginLogic from "@/components/logic/Login";
import flashMessage from "@/components/general/FlashMessage";
import mainMenu from "@/components/general/MainMenu";
import flashMessages from "@/components/general/FlashMessages";
//content component
import DashboardModule from "@/modules/DashboardModule";
import ListModule from "@/modules/ListModule";
import FormModule from "@/modules/FormModule";
import StatsModule from "@/modules/StatsModule";
import InfoModule from "@/modules/InfoModule";
import StatsGalerieModule from "@/modules/StatsGalerieModule";
import ViewModule from "@/modules/ViewModule";
import offlineDetect from "@/components/general/OfflineDetect";
import axios from "axios";
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import general from "@/components/config/general";
import DashboardUniversalModule from "@/modules/DashboardUniversalModule.vue";
import ViewBrowser from "@/components/general/view/ViewBrowser.vue";
export default {
  name: 'ContentView',
  components: {
    DisplayDebug,
    DashboardModule,
    ListModule,
    FormModule,
    StatsModule,
    StatsGalerieModule,
    ViewModule,
    loginLogic,
    flashMessages,
    mainMenu,
    offlineDetect,
    InfoModule,
    DashboardUniversalModule,
    ViewBrowser,
  },
  data() {
    return {
      status:{
        is_loading: false,
        is_err: false,
        err: null,
      },
      reloadSignal: null,
      listFilters: null,
      moduleObj: {},
      user: {},
      err: {},
      contentLoadingStatus: false,
      routes: {},
      returnData: {},
      filterValues: {},
    }
  },
  methods: {
    async getModule(name){
      //console.log("dev CONTENT VIEW  getModule", name, this.listFilters)
      //sestaveni cesty k API endpointu
      let apiPath = "/class/" + this.$route.params.modul + "/" + this.$route.params.action;

      if (typeof this.$route.params.id != undefined && this.$route.params.id){
        apiPath += "/" + this.$route.params.id;
      }
      //povolene queries
      if (this.$route.query != undefined && this.$route.query){
        let pathQuery = []
        const qObj = this.$route.query;
        for (let key in qObj) {
         if(this.getConfig('allowed_query_names').includes(key)) {
           pathQuery.push(key + "=" + this.$route.query[key])
         }
        }

        //Filtry - start
        try {
          const filters = {};
          /*
          if(
              this.$route.params.action == 'list'
              || this.$route.params.action == 'dashboard-available'
          ) {
*/
            if(this.$route.query.filters){
              const queryJson = JSON.parse(this.$route.query.filters);
              for (const i in queryJson){
                if(queryJson[i]){
                  filters[i] = queryJson[i];
                }
              }
            }


            let filtersLocalStorage = localStorage.getItem(this.$route.params.modul + this.getConfig('filter_ident'))
            if(filtersLocalStorage){
              filtersLocalStorage = JSON.parse(filtersLocalStorage);
              for (const i in filtersLocalStorage){
                if(typeof filters[i] == "undefined"){
                  filters[i] = filtersLocalStorage[i];
                }
              }
            }

            this.filterValues = filters;

            let url =  '#' + this.$route.path ;
            let params = [];
            if(this.$route.query.page && this.$route.query.page > 1){
              params.push("page=" + this.$route.query.page);
            }
            //
            if(filters && Object.keys(filters).length > 0){
              params.push("filters=" + JSON.stringify(filters));
              pathQuery.push( "filters=" + JSON.stringify(filters)); //build path
            }
            if(params && params.length > 0){
              url += "?" + params.join('&');
            }


            //history.pushState({}, null, url);
          //}

        }catch (error) {
          console.log('dev.listFilters LOAD ERR', error);
        }

        if(localStorage.getItem(general.lang_id_local_storage_name)) {
          pathQuery.push( "lang_code=" + localStorage.getItem(general.lang_id_local_storage_name))
        }

        //build path
        if(pathQuery.length > 0) apiPath += "?" + pathQuery.join("&");
      }

        this.contentLoadingStatus = false; //TODO del
        this.status.is_loading = true;
        axios.defaults.baseURL = this.getBaseRoot();



      //console.log("dev getModule DATA 4LANG apiPath", apiPath)
        await axios({
          url: apiPath,
          method: "get",
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {

          console.log("dev getModule DATA v2", this.filterValues, apiPath, res.data.response)

          if (res.data.status) {
            this.status.is_err = false;
            this.moduleObj = res.data.response;
            //filter values
            if (this.moduleObj.filters){
              for (const f in this.moduleObj.filters) {
                //console.log('dev.listFilters LOAD DATA 2',f, this.filterValues[f], this.moduleObj.filters[f]);
                if (typeof this.filterValues[f] != "undefined"){
                  this.moduleObj.filters[f].value = this.filterValues[f];
                }
              }
            }

            this.moduleObj.filterValues = this.filterValues;
            //console.log('dev.listFilters LOAD DATA 1', this.moduleObj.filters);

            if (res.data.response.title) this.setDocumentTitle(res.data.response.title, res.data.response.modul);
          }else{
            this.status.is_err = true;
            this.status.err = res.data.err;
            //document.title = 'CHYBA!';
            this.setDocumentTitle('CHYBA!');
          }
        })
        .catch((err) => {
          this.status.is_err = true;
          //this.status.err = res.data.err;
          this.status.err = err;
          this.setDocumentTitle('CHYBA!(2)');
        })
        .finally(() => {


          //console.log("DEV finally", res);
          this.status.is_loading = false;
        })
    },
  },
  watch: {
    reloadSignal: {
      handler() {
        this.getModule('change signal');
      },
      immediate: true
    },

    '$route' (to, from) {
      this.getModule('change route');
    }
  },
  created() {
    //this.routes = this.$route.params;
    //this.getModule('created');
    //console.log("dev content created / route", this.$route.params, this.$route.query)
    //this.getModule();
  },
  mounted() {
    //console.log("dev content mounted X-1")
    //console.log("dev content mounted / route", this.$route.params)
    //console.log('dev view mounted')
    //this.getModule();
  },
}
</script>
<style lang="scss" scoped>
.cms5-top-menu-wrap {
  max-width: 20vh;
}

</style>